export default __webpack_public_path__ + "static/footer_image-a335c33520b659dba142c75a84f84937.jpg";